import React from "react";
import { useQuery } from "react-apollo";
import MUIDataTable from "mui-datatables";

import { Grid } from "@material-ui/core";

import { FIND_ADUNITS_BY_PLUBLISHERID } from "../../../queries/adUnit";
import DeleteAdUnit from "./delete";

import DrawerPlacements from "../../../components/DrawerPlacements";
import PageError from "../../../components/PageError";
import PageLoading from "../../../components/PageLoading";
import PageTitle from "../../../components/PageTitle/PageTitle";
import AddAdUnits from "../../../pages/adunits/actions/create";
import UpdateAdUnits from "../../../pages/adunits/actions/edit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAd } from "@fortawesome/free-solid-svg-icons";

export const AdUnitList = props => {
  const { loading, error, data } = useQuery(FIND_ADUNITS_BY_PLUBLISHERID, {
    variables: { publisherId: props.publisherId },
  });

  const columns = [
    {
      name: "id",
      options: {
        display: false,
      },
    },
    {
      name: "publisherId",
      options: {
        empty: true,
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return ActionsRow(tableMeta);
        },
      },
    },
    {
      name: "sizes",
      options: {
        display: false,
      },
    },
    {
      name: "slot",
    },
    {
      name: "tag",
    },
  ];

  const options = {
    selectableRows: "checkbox",
    responsive: "scrollMaxHeight",
    customToolbarSelect: selectedRows => (
      <DeleteAdUnit
        selectedRows={selectedRows}
        adUnitsList={data.findAdUnitsByPublisherId}
      />
    ),
  };

  const ActionsRow = tableMeta => {
    let id = tableMeta.rowData[0];
    let publisherId = tableMeta.rowData[1];
    const input = {
      publisherId,
      sizes: tableMeta.rowData[2],
      slot: tableMeta.rowData[3],
      tag: tableMeta.rowData[4],
    };
    return (
      <>
        <DrawerPlacements
          title="Edit Ad Unit"
          iconButtonAction={false}
          labeButtonAction={publisherId}
        >
          <UpdateAdUnits id={id} {...input} publisherIds={props.publisherIds} />
        </DrawerPlacements>
      </>
    );
  };

  return (
    <>
      <DrawerPlacements
        headerButton="off"
        title="Settings"
        iconButtonAction={<FontAwesomeIcon icon={faAd} className="fa-xs" />}
      >
        <Grid container spacing={0}>
          <Grid item xs={10}>
            <PageTitle title="Ad Units" />
          </Grid>
          <Grid item xs={2}>
            <DrawerPlacements title="Ad Unit" labeButtonAction="Add">
              <AddAdUnits publisherIds={props.publisherIds}></AddAdUnits>
            </DrawerPlacements>
          </Grid>
        </Grid>

        {loading ? (
          <PageLoading />
        ) : error ? (
          <PageError />
        ) : (
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <MUIDataTable
                title={false}
                data={data.findAdUnitsByPublisherId}
                columns={columns}
                options={options}
              />
            </Grid>
          </Grid>
        )}
      </DrawerPlacements>
    </>
  );
};
